import React from 'react';
import styled from 'styled-components';

const PresentationWrapper = styled.header`
    width: 100%;
    max-width: 100%;
    min-height: 100vh;
    background: #99CBCB;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10vh 6vw;
`;

const Content = styled.div`
    width: 100%;
    max-width: 980px;
    display: flex;
    flex-direction: column;
    gap: 3vh;
`;

const Title = styled.h1`
    margin: 0;
    font-size: clamp(2rem, 6vw + 0.5rem, 4rem);
    color: #0b1b1b;
    line-height: 1.05;
`;

const Subtitle = styled.p`
    margin: 0;
    font-size: clamp(1.05rem, 2vw + 0.4rem, 1.5rem);
    color: #0b1b1b;
    max-width: 65ch;
`;

const Callout = styled.div`
    background: rgba(255,255,255,0.55);
    border: 1px solid rgba(0,0,0,0.08);
    border-radius: 14px;
    padding: 16px 18px;
    max-width: 70ch;
`;

const CalloutTitle = styled.h2`
    margin: 0 0 8px 0;
    font-size: 1rem;
    letter-spacing: 0.02em;
    text-transform: uppercase;
`;

const CalloutText = styled.p`
    margin: 0;
    font-size: 1rem;
    line-height: 1.5;
`;

const Actions = styled.div`
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    margin-top: 1vh;
`;

const Button = styled.button`
    padding: 12px 16px;
    border: none;
    border-radius: 12px;
    background: #0b1b1b;
    color: white;
    font-weight: 700;
    cursor: pointer;

    &:hover { background: #1a3333; }
    &:focus-visible { outline: 3px solid rgba(0,0,0,0.35); outline-offset: 3px; }
`;

const SecondaryButton = styled.button`
    padding: 12px 16px;
    border-radius: 12px;
    background: rgba(255,255,255,0.65);
    color: #0b1b1b;
    border: 1px solid rgba(0,0,0,0.18);
    font-weight: 700;
    cursor: pointer;

    &:hover { background: rgba(255,255,255,0.85); }
    &:focus-visible { outline: 3px solid rgba(0,0,0,0.35); outline-offset: 3px; }
`;

function Presentation() {
    const scrollToId = (id) => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    return (
        <PresentationWrapper>
            <Content>
                <Title>Voto desperdiçado: quando o teu voto não elege ninguém</Title>

                <Subtitle>
                    Nas legislativas de 2022, cerca de <strong>13,48%</strong> dos votos não elegeram deputados.
                    Este site ajuda-te a perceber <strong>se isso acontece no teu círculo</strong> — e porquê.
                </Subtitle>

                <Callout>
                    <CalloutTitle>Definição rápida</CalloutTitle>
                    <CalloutText>
                        Chamamos <strong>voto desperdiçado</strong> a um voto que, no teu círculo eleitoral, não contribui para eleger deputados
                        (porque o partido não atinge representação nesse círculo).
                    </CalloutText>
                </Callout>

                <Actions>
                    <Button type="button" onClick={() => scrollToId('simulador')}>Experimentar o simulador</Button>
                    <SecondaryButton type="button" onClick={() => scrollToId('visualizacao')}>Ver a visualização</SecondaryButton>
                </Actions>
            </Content>
        </PresentationWrapper>
    );
}

export default Presentation;
